import apiService from "./apiService";
import AppConstants from "../appConstants";

class AcceptorService {
  requestNewToken(form, params) {
    console.log('[requestNewToken][Service] init function');
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_ACCEPTOR_NEW_TOKEN, form, params)
        .then(response => {
          console.log('[requestNewToken][Service][RESPONSE]', response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  }

  refreshToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_ACCEPTOR_REFRESH_TOKEN, form, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
  checkToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_ACCEPTOR_CHECK_TOKEN, form, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }

  logout(form, params) {
    return new Promise((resolve, reject) => {
      apiService.postKeepAlive(AppConstants.URL_ACCEPTOR_LOGOUT, form, params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
}

export default new AcceptorService();
